import { Validators } from '@angular/forms';
import { IColumnConfigTableResponsive } from 'src/app/domain/IColumnConfigTableResponsive';
import { FieldTypeEnum } from 'src/app/domain/registration/enums/field-type.enum';
import { SystemActionCategoryTypeEnum } from 'src/app/domain/registration/enums/system-action-category-type.enum';
import { TableResponsiveTypeColumnEnum } from 'src/app/domain/registration/enums/table-responsive-type-column.enum';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { SystemActionCategoryIndexSelectComponent } from '../system-action-categories/crud-index/crud-index-select.component';
import { SystemActionIndexSelectComponent } from '../system-actions/crud-index/crud-index-select.component';

export const RELATIVE_URL = 'system-action-params';

export const COLUMNS_TO_SHOW_WEB = [
  'code',
  'systemActionCategoryType',
  'systemAction',
  'name',
  'actions',
];
export const COLUMNS_TO_SHOW_MOBILE = COLUMNS_TO_SHOW_WEB;
export const TABLE_CONFIG_COLUMNS: IColumnConfigTableResponsive[] = [
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'code',
    display: 'CÓDIGO',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'systemActionCategoryType',
    display: 'TIPO',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'systemAction',
    display: 'AÇÃO DO SISTEMA',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'name',
    display: 'NOME',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
];

export const CES_CONFIG_FIELDS = [
  {
    type: TypeComponentFieldEnum.HIDDEN,
    name: 'id',
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'Tipo de Ação do Sistema',
    name: 'systemActionCategoryType',
    options: Object.values(SystemActionCategoryTypeEnum),
  },
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    label: 'Categoria de Ação do Sistema',
    component: SystemActionCategoryIndexSelectComponent,
    name: 'systemActionCategory',
    placeholder: 'Selecione uma opção',
  },
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    label: 'Ação do Sistema',
    component: SystemActionIndexSelectComponent,
    name: 'systemAction',
    placeholder: 'Selecione uma opção',
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'NOME',
    name: 'name',
    placeholder: 'Insira o nome',
    validation: [Validators.required, Validators.minLength(4)],
  },
  {
    labelSave: 'Salvar',
    labelCancel: 'Cancelar',
    name: 'cancelSave',
    type: TypeComponentFieldEnum.CANCEL_SAVE,
  },
];
